module.exports = __webpack_public_path__ + "static/contact-0c90af4ed630a23294a8143cb78e9a93.svg";